import { motion } from "framer-motion";
import { MapPin, Wallet, Inbox, ArrowRight, BadgeCheck } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

export default function ForCustomers() {
  return (
    <section id="for-customers" data-testid="for-customers-section" className="py-20 md:py-28 overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal>
          <Eyebrow>For customers</Eyebrow>
          <h2 className="mt-4 font-display font-extrabold tracking-tight text-navy text-3xl sm:text-4xl lg:text-5xl">
            Need a job done?
          </h2>
          <p className="mt-5 text-base sm:text-lg text-slate-600 leading-relaxed max-w-md">
            Whether it's assembling furniture, mounting a TV or getting help moving, post the job and let local
            people come to you.
          </p>
          <a
            href="#app"
            data-testid="customers-post-job-btn"
            className="group mt-8 inline-flex items-center gap-2 bg-teal hover:bg-teal-hover text-navy font-semibold px-8 py-4 rounded-full shadow-lg shadow-teal/25 transition-colors duration-200"
          >
            Post a Job
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-200" />
          </a>
        </Reveal>

        <Reveal delay={0.15} className="relative">
          <div className="absolute -top-10 -right-10 w-64 h-64 rounded-full bg-teal/10 blur-3xl pointer-events-none" />
          <motion.div
            data-testid="customers-job-preview"
            whileHover={{ y: -6 }}
            transition={{ type: "spring", stiffness: 300, damping: 22 }}
            className="relative max-w-md mx-auto bg-white rounded-3xl border border-slate-200/80 shadow-2xl shadow-navy/10 p-7"
          >
            <div className="flex items-center justify-between">
              <span className="font-mono text-[11px] uppercase tracking-wider text-slate-400">Your job</span>
              <span className="inline-flex items-center gap-1 text-[11px] font-semibold bg-teal/10 text-teal px-2.5 py-1 rounded-full">
                <Inbox className="w-3 h-3" /> 5 offers
              </span>
            </div>
            <h3 className="mt-3 font-display font-extrabold text-navy text-2xl tracking-tight">
              Build my IKEA wardrobe
            </h3>
            <div className="mt-5 grid grid-cols-2 gap-3">
              <div className="bg-paper rounded-xl p-4">
                <p className="flex items-center gap-1.5 text-[11px] text-slate-400 font-medium">
                  <MapPin className="w-3.5 h-3.5 text-teal" /> Location
                </p>
                <p className="mt-1 font-display font-bold text-navy">London</p>
              </div>
              <div className="bg-paper rounded-xl p-4">
                <p className="flex items-center gap-1.5 text-[11px] text-slate-400 font-medium">
                  <Wallet className="w-3.5 h-3.5 text-teal" /> Budget
                </p>
                <p className="mt-1 font-display font-bold text-navy">£80</p>
              </div>
            </div>
            <div className="mt-5 pt-5 border-t border-slate-100">
              <p className="text-[11px] text-slate-400 font-medium mb-3">Latest offers</p>
              {[
                { ini: "SK", name: "Sofia K.", price: "£75", bg: "bg-teal" },
                { ini: "JM", name: "James M.", price: "£80", bg: "bg-navy" },
              ].map((o) => (
                <div key={o.ini} className="flex items-center justify-between py-2">
                  <div className="flex items-center gap-3">
                    <span
                      className={`w-9 h-9 rounded-full ${o.bg} grid place-items-center text-[11px] font-bold text-white`}
                    >
                      {o.ini}
                    </span>
                    <div>
                      <p className="text-sm font-semibold text-navy flex items-center gap-1">
                        {o.name} <BadgeCheck className="w-3.5 h-3.5 text-teal" />
                      </p>
                      <p className="text-[11px] text-slate-400">Available today</p>
                    </div>
                  </div>
                  <span className="font-display font-bold text-navy">{o.price}</span>
                </div>
              ))}
            </div>
          </motion.div>
        </Reveal>
      </div>
    </section>
  );
}
